import './participantsPicker.scss';

import { useIntl } from 'react-intl';
import { Chip, ChipGroup } from '@eliberty/design-system-react';

import { SELECTOR_MODE } from '~constants';
import { getParticipantTitle } from '~helpers';
import { Participant } from '~types/participant';

interface ParticipantsPickerProps {
  /** The participants to display in selector */
  participants: Participant[];
  /** The selected participants */
  selected?: Participant[];
  /** The mode for participant display */
  participantMode: SELECTOR_MODE;
  /** The callback function called when a set of participants is selected */
  onParticipantsSelect: (selectedParticipants: Participant[]) => void;
}

const ParticipantsPicker = ({
  participants,
  selected,
  participantMode,
  onParticipantsSelect,
}: ParticipantsPickerProps) => {
  const intl = useIntl();

  const handleSelectParticipants = (updatedSelection: string[]) => {
    onParticipantsSelect(
      participants.filter((participant) => updatedSelection.includes(`${participant.id}`)),
    );
  };

  return (
    <div className='ParticipantsPicker'>
      <ChipGroup
        multiple
        value={selected?.map((participant) => `${participant.id}`)}
        onChange={handleSelectParticipants}
      >
        {participants.map((participant) => {
          const { participantLabel, participantSubLabel } = getParticipantTitle(
            participant,
            intl,
            participantMode,
            participants,
          );

          return (
            <Chip
              key={participant.id}
              label={participantLabel}
              subLabel={participantSubLabel}
              value={`${participant.id}`}
            />
          );
        })}
      </ChipGroup>
    </div>
  );
};

export default ParticipantsPicker;
